import { EVENT_DEFAULT_RADIUS } from '../../shared/constants';
import { Availability } from './availability.enum';

export class EventParams {
  location?: {
    lng: number;
    lat: number;
  };
  radius = EVENT_DEFAULT_RADIUS;
  region?: string; // id of the region
  availability: Availability[] = [];
  bookedOnly?: boolean;
  freeSpots?: number;
  selectedCategories: string[] = [];
  page = 1;
  maxDistance = EVENT_DEFAULT_RADIUS;
  date?: string;
  sortBy?: 'location' | 'date';
  sortDirection?: number;

  constructor(eventParams?: Partial<EventParams>) {
    Object.assign(this, eventParams || {});
  }
}
